
<template>

  <body>
   <div id="header">
    <div class="header-inner">
      <h1><a href="index.html"><img width="382" height="56" src="../../static/images/logo.png" alt="小白保险logo" title="小白保险"/></a></h1>
      <a id="zysq-introduce" href="http://mp.weixin.qq.com/s?__biz=MzAxNzA5Mjc5Ng==&mid=201323575&idx=1&sn=619210f13033538428fa23ae023508e8&scene=1#rd" target="_blank">展业神器简介</a>
    </div>
  </div>
  <div class="clearfix"></div><!--ie7兼容-->
  <!--内容-->
   <div id="content">
     <div id="about-content" class="join-content clearfix">
       <h1 class="join-title">这在这里，你将拥有宽松、愉悦、平等的工作环境，你将收获友爱、尊重、温暖的创业伙伴，更重要的是，你有可能实现自己最大的价值。</h1>
       <div class="join-mail">
         <h2>简历投递</h2>
         <p>hr@xiaobaibao.com</p>
       </div>
       <div class="join-table clearfix">
         <div class="table-cell first-cell">热门</div>
         <div class="table-cell">技术</div>
         <div class="table-cell">产品</div>
         <div class="table-cell">设计</div>
         <div class="table-cell">市场</div>
         <div class="table-cell">运营</div>
         <div class="table-cell">销售</div>
         <div class="table-cell">行政</div>
         <div class="table-cell">客服</div>
       </div>
       <div class="rec_list clearfix">
         <ul class="rec_list_l">
           <li><a href="http://search.51job.com/job/69886705,c.html" target="_blank" title="财险业务经理">财险业务经理 [ 广州-越秀区 ]</a></li>
         </ul>
         <ul class="rec_list_r">
           <li><a href="http://search.51job.com/job/69885719,c.html" target="_blank" title="Java高级开发工程师">Java高级开发工程师 [ 广州-越秀区 ] </a></li>
         </ul>
       </div>
     </div>
   </div>
  </body>
</template>
<script>
    export default {
        name: "join",
        data() {
            return{
            }

        },
        methods: {
        },
        mounted() {

        }
    }
</script>

<style scoped>
  @import "../../static/css/rcMain/about.css";
  @import "../../static/css/rcMain/common.css";

  #content{
    padding: 178px 0 60px;
    margin: 0 auto;
    overflow: auto;
    height: calc(100vh - 70px);
  }


</style>



// WEBPACK FOOTER //
// src/components/join.vue